module.exports = __webpack_public_path__ + "img/github-backup-automation.47656c65.png";